<template>
    <div class="file-viewer-wrapper">
        <v-zoomer class="image-zoomer" ref="zoomer" v-if="this.pageImage">
            <img style="page-image" :src="pageImage" />
        </v-zoomer>

        <div class="page-controls">
            <button
                v-on:click="prevPage"
                :disabled="this.currentPage === 1"
                class="btn btn-secondary"
            >
                <i class="fas fa-angle-left"></i>
            </button>
            <span class="page-number">{{ currentPage }} / {{ pageCount || '?' }}</span>
            <button
                v-on:click="nextPage"
                :disabled="this.currentPage === this.pageCount"
                class="btn btn-secondary"
            >
                <i class="fas fa-angle-right"></i>
            </button>
            <span v-if="jobComplete === false" class="processing-text">Still Processing</span>
        </div>

        <div class="back-btn">
            <a href="/" class="btn btn-primary"><i class="fas fa-angle-left"></i> Go Back</a>
        </div>
    </div>
</template>

<script>
export default {
    props: ["jobid"],
    data() {
        return {
            status: null,
            currentPage: 1,
            pageCount: null,
            jobComplete: false,
            pages: [],
            statusCheckInterval: null
        };
    },
    mounted() {
        this.statusCheckInterval = setInterval(() => {
            this.fetchJobStatus();
        }, 1000);
    },
    methods: {
        nextPage() {
            if (this.currentPage < this.pageCount) {
                this.currentPage += 1;
                this.$refs.zoomer.reset();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.$refs.zoomer.reset();
            }
        },
        fetchJobStatus() {
            axios.get(`/api/${this.jobid}/status`)
                .then(res => {
                    const { data } = res;

                    // Parse the data out so the component can react accordingly
                    this.jobComplete = data.status !== 'processing' ? true : false;
                    this.pageCount = data.pagecount;
                    this.pages = data.pages;
                    
                    // If the job is complete, we don't need to keep pinging the endpoint
                    if (this.jobComplete) {
                        clearInterval(this.statusCheckInterval);
                        this.statusCheckInterval = null;
                    }
                })
                .catch(err => {
                    console.error(err);
                })
        }
    },
    computed: {
        pageImage() {
            return this.pages[this.currentPage - 1];
        }
    }
};
</script>
